import {create} from "zustand";
import axios from "axios";
import {api} from "./api";

export const useContactStore = create((set, get) => ({
    socials: [],
    addresses: [],
    emails: [],
    phones: [],
    loading: false,
    error: null,
    getSocials: async () => {
        set({loading: true, error: null});
        try {
            const {data} = await axios.get(
                `${api}/public/contact-information`
            );
            set({
                socials: data.socials,
                loading: false,
            });
            return data;
        } catch (e) {
            set({
                error: e.response?.data || "Ошибка",
                loading: false,
            });
            console.error(e);
        }
    },
    getAddresses: async () => {
        set({loading: true, error: null});
        try {
            const {data} = await axios.get(
                `${api}/public/contact-information`
            );
            set({
                addresses: data.addresses,
                loading: false,
            });
            return data;
        } catch (e) {
            set({
                error: e.response?.data || "Ошибка",
                loading: false,
            });
            console.error(e);
        }
    },
    getEmails: async () => {
        set({loading: true, error: null});
        try {
            const {data} = await axios.get(
                `${api}/public/contact-information`
            );
            set({
                emails: data.emails,
                loading: false,
            });
            return data;
        } catch (e) {
            set({
                error: e.response?.data || "Ошибка",
                loading: false,
            });
            console.error(e);
        }
    },
    getPhones: async () => {
        set({loading: true, error: null});
        try {
            const {data} = await axios.get(
                `${api}/public/contact-information`
            );
            set({
                phones: data.phones,
                loading: false,
            });
            return data;
        } catch (e) {
            set({
                error: e.response?.data || "Ошибка",
                loading: false,
            });
            console.error(e);
        }
    },
}));

export const useGetSocials = () => useContactStore((state) => state.getSocials);
export const useSocials = () => useContactStore((state) => state.socials);
export const useGetAddresses = () => useContactStore((state) => state.getAddresses);
export const useAddresses = () => useContactStore((state) => state.addresses);
export const useGetEmails = () => useContactStore((state) => state.getEmails);
export const useEmails = () => useContactStore((state) => state.emails);
export const useGetPhones = () => useContactStore((state) => state.getPhones);
export const usePhones = () => useContactStore((state) => state.phones);